module.exports = __webpack_public_path__ + "assets/images/ert2sport.126556e696649b95690b4506636787a7.png";